export default "__VITE_ASSET__B3We_81M__"